<template>
  <router-view/>
</template>

<script>
export default {
  name: 'AppIndex'
}
</script>



// WEBPACK FOOTER //
// src/components/pages/index.vue